import feesDataConstant from '@giro-pdv-terminal/constants/feesData.constant';
import stepsConstant from '@giro-pdv-terminal/constants/steps.constant';

const initialState = {
  step: stepsConstant.welcome,
  lastStep: null,
  methodPayment: null,
  amount: null,
  feesData: null,
  typeTax: null,
  return: 0,
  retornoGiro: false,
  installmentSelected: null,
  resultStatus: null,
  logSocket: [],
};

const mock = {
  step: 3,
  lastStep: 2,
  methodPayment: 'pix',
  amount: 1,
  feesData: [
    {
      vlFator: 0.9832841691,
      nuParcelas: 1,
      cdTipoTaxa: 1,
      cdTipoTransacao: 2,
      cdTabTaxa: 0,
    },
    {
      vlFator: 1.017,
      nuParcelas: 1,
      cdTipoTaxa: 1,
      cdTipoTransacao: 3,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.9576,
      nuParcelas: 1,
      cdTipoTaxa: 2,
      cdTipoTransacao: 2,
      cdTabTaxa: 0,
    },
    {
      vlFator: 1.0442773601,
      nuParcelas: 1,
      cdTipoTaxa: 2,
      cdTipoTransacao: 3,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.4709616968,
      nuParcelas: 2,
      cdTipoTaxa: 2,
      cdTipoTransacao: 2,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.5308287313,
      nuParcelas: 2,
      cdTipoTaxa: 2,
      cdTipoTransacao: 3,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.3102261543,
      nuParcelas: 3,
      cdTipoTaxa: 2,
      cdTipoTransacao: 2,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.3581616494,
      nuParcelas: 3,
      cdTipoTaxa: 2,
      cdTipoTransacao: 3,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.2298586912,
      nuParcelas: 4,
      cdTipoTaxa: 2,
      cdTipoTransacao: 2,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.2719061858,
      nuParcelas: 4,
      cdTipoTaxa: 2,
      cdTipoTransacao: 3,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.1816380634,
      nuParcelas: 5,
      cdTipoTaxa: 2,
      cdTipoTransacao: 2,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.2202181594,
      nuParcelas: 5,
      cdTipoTaxa: 2,
      cdTipoTransacao: 3,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.1494909781,
      nuParcelas: 6,
      cdTipoTaxa: 2,
      cdTipoTransacao: 2,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.1858157471,
      nuParcelas: 6,
      cdTipoTaxa: 2,
      cdTipoTransacao: 3,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.1261751213,
      nuParcelas: 7,
      cdTipoTaxa: 2,
      cdTipoTransacao: 2,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.1617447486,
      nuParcelas: 7,
      cdTipoTaxa: 2,
      cdTipoTransacao: 3,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.1090016035,
      nuParcelas: 8,
      cdTipoTaxa: 2,
      cdTipoTransacao: 2,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.1433465151,
      nuParcelas: 8,
      cdTipoTaxa: 2,
      cdTipoTransacao: 3,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.0956444228,
      nuParcelas: 9,
      cdTipoTaxa: 2,
      cdTipoTransacao: 2,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.1290789222,
      nuParcelas: 9,
      cdTipoTaxa: 2,
      cdTipoTransacao: 3,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.0849586782,
      nuParcelas: 10,
      cdTipoTaxa: 2,
      cdTipoTransacao: 2,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.1177042794,
      nuParcelas: 10,
      cdTipoTaxa: 2,
      cdTipoTransacao: 3,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.0762157961,
      nuParcelas: 11,
      cdTipoTaxa: 2,
      cdTipoTransacao: 2,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.1084350388,
      nuParcelas: 11,
      cdTipoTaxa: 2,
      cdTipoTransacao: 3,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.0709063189,
      nuParcelas: 12,
      cdTipoTaxa: 2,
      cdTipoTransacao: 2,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.0979383016,
      nuParcelas: 12,
      cdTipoTaxa: 2,
      cdTipoTransacao: 3,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.0626984384,
      nuParcelas: 13,
      cdTipoTaxa: 2,
      cdTipoTransacao: 2,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.0943749145,
      nuParcelas: 13,
      cdTipoTaxa: 2,
      cdTipoTransacao: 3,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.0574198998,
      nuParcelas: 14,
      cdTipoTaxa: 2,
      cdTipoTransacao: 2,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.0888549237,
      nuParcelas: 14,
      cdTipoTaxa: 2,
      cdTipoTransacao: 3,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.0528451662,
      nuParcelas: 15,
      cdTipoTaxa: 2,
      cdTipoTransacao: 2,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.0841031406,
      nuParcelas: 15,
      cdTipoTaxa: 2,
      cdTipoTransacao: 3,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.0488422741,
      nuParcelas: 16,
      cdTipoTaxa: 2,
      cdTipoTransacao: 2,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.0799768248,
      nuParcelas: 16,
      cdTipoTaxa: 2,
      cdTipoTransacao: 3,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.0453103103,
      nuParcelas: 17,
      cdTipoTaxa: 2,
      cdTipoTransacao: 2,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.0763668928,
      nuParcelas: 17,
      cdTipoTaxa: 2,
      cdTipoTransacao: 3,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.0440994686,
      nuParcelas: 18,
      cdTipoTaxa: 2,
      cdTipoTransacao: 2,
      cdTabTaxa: 0,
    },
    {
      vlFator: 0.0699876859,
      nuParcelas: 18,
      cdTipoTaxa: 2,
      cdTipoTransacao: 3,
      cdTabTaxa: 0,
    },
  ],
  typeTax: 'client',
  return: 0,
  retornoGiro: false,
  installmentSelected: null,
  resultStatus: null,
  logSocket: [
    {
      states: [
        {
          event: 'pdv-terminal::method_payment',
          payload: {
            method_payment: 'pix',
          },
          state: 'updated',
        },
      ],
      date: '2023-10-22T03:41:07.203Z',
    },
    {
      states: [
        {
          CdTransacao: null,
          CdAmbienteOperadora: 2,
          CdCliente: 3027,
          CdUsuario: 2262,
          CdInterface: 3,
          CdSegmento: '4',
          CdTipoCusto: null,
          CdTipoPagamento: 3,
          CdTipoTransacao: 1,
          DsCardHolder: null,
          DsBinCartao: null,
          CdBandeira: null,
          QtParcelas: 1,
          VlTransacao: 1,
          VlLiberado: '1',
          CdAdquirente: 3,
          VlParcela: '0.00',
          IdTransacao: null,
          DsRetorno: 'R0',
          VlRetorno: 0,
          DtQuitacao: null,
          CdStatusTransacao: 2,
          DsMensagemTransacao: null,
          CdTabTaxa: null,
          PdvVersion: null,
          Venda: {
            CdTransacao: 0,
            CdSegmento: '4',
            VendaDespachante: null,
            VendaGeral: {
              cdCliente: 3027,
              cdTransacao: 0,
              dsIdentificacaoCliente: null,
              vlMaterial: 1,
              vlServicos: 0,
            },
            VendaVeiculo: null,
            VendaTributo: null,
            VendaDetran: null,
            VendaHospital: null,
            VendaAssessoria: null,
            Pagamentos: null,
            VendaCrea: null,
          },
          status: 'PROCESSANDO',
          meta: 1241380658,
          referencia_externa: '791b5547600e-4d3',
          referencia_id: '51uRExNkE9OHFER1g0X',
          qrcode_data:
            '00020101021226860014BR.GOV.BCB.PIX2564api.rendimento.com.br/q/v2/cobv/0292ca8d779b44da9c2b72c67d19126b5204000053039865802BR5923GIRO PAGAMENTOS E TECNO6007S PAULO62070503***6304C886',
          qrcode:
            'data:image/png;base64,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',
          state: 'updated',
        },
      ],
      date: '2023-10-22T03:41:09.598Z',
    },
    {
      states: [
        {
          referencia_id: '51uRExNkE9OHFER1g0X',
          referencia_externa: '791b5547600e-4d3',
          status: 'PAGO',
          state: 'completed',
        },
      ],
      date: '2023-10-22T03:42:41.004Z',
    },
  ],
};

export default initialState;
